module.exports = __webpack_public_path__ + "media/images/patient-icons/communication-icon-7366555eff6b45369172f7007cc9d6a8.svg";